import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import React from 'react';

type Props = {
  id?: string;
  value: string;
  onChange: (val: string) => void;
  min?: string;
  max?: string;
  className?: string;
  wrapperStyle?: React.CSSProperties;
  placeholder?: string;
};

function isoToDate(iso: string | undefined): Date | null {
  if (!iso) return null;
  const parts = iso.split('-').map(Number);
  if (parts.length !== 3 || parts.some(isNaN)) return null;
  return new Date(parts[0], parts[1] - 1, parts[2]);
}

function dateToIso(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function AppDatePicker({ id, value, onChange, min, max, className, wrapperStyle, placeholder }: Props) {
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  const picker = (
    <DatePicker
      id={id}
      selected={isoToDate(value)}
      onChange={(d:any) => onChange(d ? dateToIso(d) : '')}
      dateFormat="MM/dd/yyyy"
      minDate={isoToDate(min) ?? undefined}
      maxDate={isoToDate(max) ?? today}
      placeholderText={placeholder ?? 'mm/dd/yyyy'}
      className={className ?? 'form-control'}
      wrapperClassName="app-datepicker-wrapper"
      autoComplete="off"
    />
  );
  return wrapperStyle ? <div style={wrapperStyle}>{picker}</div> : picker;
}
